import { Text } from "@chakra-ui/react";
import Page from "../components/Page";
import FaqSection from "../components/Faq";
import { faqData } from "../data/faqData";

export default function Faq() {
	return (
		<Page title="FAQ" heading="Frequently Asked Questions">
			<FaqSection
				items={faqData}
				showHeader={false}
				footer={
					// Points to the contact info at the bottom of the page
					<Text
						textAlign={"center"}
						fontFamily={"Montserrat"}
						fontWeight={500}
						fontSize={{ base: "md", md: "lg" }}
						color={"white.500"}
					>
						Have a different question? Feel free to contact our office below.
					</Text>
				}
			/>
		</Page>
	);
}
